import React, { Fragment, useEffect, useState, useContext, useRef } from 'react';
import { Link, useNavigate, useSearchParams, useParams, useLocation } from 'react-router-dom';
import { Button, Input, Select } from "antd";
import { Context } from '../context';
import texts from './texts.json';
import { SearchOutlined } from '@ant-design/icons';


export function Filters(props) {
  const context = { ...useContext(Context) };
  const { children } = { ...props };
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [state, setState] = useState();

  const AUDIOS_COUNT = 16;

  const tagCloudConfig = {
    '20': { fontSize: '1.6em', opacity: 1, padding: '.4rem .1rem' },
    '15': { fontSize: '1.5em', opacity: 1, padding: '.3rem .1rem' },
    '10': { fontSize: '1.4em', opacity: 1, padding: '.2rem .1rem' },
    '8': { fontSize: '1.3em', opacity: 1, padding: '.1rem .1rem' },
    '5': { fontSize: '1.2em', opacity: 1, padding: '.1rem .1rem' },
    '3': { fontSize: '1.1em', opacity: 0.8, padding: '.1rem .1rem' },
    '1': { fontSize: '0.8em', opacity: 0.6, padding: '.1rem .1rem' },
  };

  const getTagCloudStyle = (count) => {
    // Sort keys in descending order to find the first matching threshold
    const thresholds = Object.keys(tagCloudConfig)
      .map(Number)
      .sort((a, b) => b - a);

    for (const threshold of thresholds) {
      if (count >= threshold) {
        return tagCloudConfig[threshold.toString()];
      }
    }
    // Fallback to smallest if count is 0
    return tagCloudConfig['1'];
  };

  const handleVenue = (value) => {
    console.log(value);
    const venueValue = typeof value === 'object' && value !== null ? value.value : value;
    context.x.setFilterVenue(venueValue)
    const v = context.x.filterContent(context.videos, { fv: venueValue, fy: context.state.filterYear })
    if (!v.length) {
      context.x.setFilterYear()
      context.x.setFilterTag()
    }
    setMenu(false)
    smoothScrollTo('videos')
  };
  const handleYear = (value) => {
    // console.log(value);
    const yearValue = typeof value === 'object' && value !== null ? value.value : value;
    context.x.setFilterYear(yearValue)
    const v = context.x.filterContent(context.videos, { fy: yearValue, fv: context.state.filterVenue })
    if (!v.length) {
      context.x.setFilterVenue()
      context.x.setFilterTag()
    }
    setMenu(false)
    smoothScrollTo('videos')
  };
  const reset = () => {
    handleVenue({ value: '' })
    handleYear({ value: '' })
    context.x.setSearch('')
    setMenu(false)
  };

  const [menu, setMenu] = useState(false)


  const smoothScrollTo = (targetId) => {
    const target = document.getElementById(targetId);
    if (target) {
      // Update the URL hash without jumping
      window.history.pushState(null, null, `#${targetId}`);

      // Scroll to the target smoothly
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const filterByTag = (tag) => {
    context.x.setFilterTag(tag)
    const v = context.x.filterContent(context.videos, {
      ft: tag,
      fv: context.state.filterVenue,
      fy: context.state.filterYear,
      s: context.state.search
    })
    if (!v.length) {
      context.x.setFilterVenue()
      context.x.setFilterYear()
      context.x.setSearch()
    }
    smoothScrollTo('videos')
    setMenu(false)
  }




  return (
    <>


      <a href='#videos' className="x_mob_menu"
        onClick={() => setMenu(true)}
      >
        <div className="_ico" style={{ fontSize: '2em' }}>search</div>
      </a>
      {menu && <div className="x_mob_z" onClick={() => setMenu(false)} />}

      <div className={`x_v_search ${menu ? 'active' : ''}`}>

        <div className="x_menu " style={{ fontSize: '0.8em' }}>

          {/* <div className="x_menu_line" style={{ paddingRight: 0 }}>
            <div className="x_menu_sub_h ">
              <div className="x_menu_sub_h1">{texts[context.state.language].ui.categories}</div>
            </div>

            <div className="x_menu_line x_menu_sub x_menu_sub--y " >
              {context.videoCategories.map(one => {
                return <a href={`#${one.id}`} className={`x_menu_sub_li x_menu_sub_li--y ${context.state.filterVenue === one.id ? 'active' : ''}`}
                  key={`${one.id}-${one.title}`}
                  onClick={() => smoothScrollTo(one.id)}
                >
                  <div className="x_menu_sub_text">
                    <div className="x_menu_sub_title">{one.title}</div>
                  </div>
                  {Boolean(one.videos.length) && <div className="x_menu_sub_counter _o04">{one.videos.length}</div>}
                  {Boolean(one.id === 'audio') && <div className="x_menu_sub_counter _o04">{AUDIOS_COUNT}</div>}
                </a>
              })}
            </div>
          </div> */}

          <div className="x_menu_line x_menu_line--scroll" style={{ paddingRight: 0 }}>
            <div className="x_menu_sub_h ">
              <div className="x_menu_sub_h1">{texts[context.state.language].ui.tags}</div>
              {Boolean(context.state.filterTag) && <div className="x_button active" onClick={() => context.x.setFilterTag('')}>
                <div className="_ico">clear</div>
              </div>}
            </div>

            <div className="x_menu_tagcloud" >
              <div className="x_menu_line x_menu_sub x_menu_sub--y " >
                {(() => {
                  // Calculate video count for each tag
                  const tagsWithCount = (context.videoTags || []).map(tag => {
                    const count = (context.videos || []).filter(video =>
                      video.tags && video.tags.includes(tag)
                    ).length;
                    return { tag, count };
                  })
                    // Sort by count (descending)
                    .sort((a, b) => b.count - a.count)
                    // Filter out tags with 0 videos
                    .filter(item => item.count > 0);

                  return tagsWithCount.map(({ tag, count }) => {
                    const cloudStyle = getTagCloudStyle(count);
                    return <div href={`#${tag}`} className={`x_menu_sub_li x_menu_sub_li--y ${context.state.filterTag === tag ? 'active' : ''}`}
                      key={`tag-${tag}`}
                      onClick={() => filterByTag(tag)}
                    >
                      <div className="x_menu_sub_text">
                        <div className="x_menu_sub_title" style={{ ...cloudStyle }}>
                          {tag}
                        </div>
                      </div>
                      <div className="x_menu_sub_counter _o04">{count}</div>
                    </div>
                  });
                })()}
              </div>
            </div>


          </div>

          {Boolean(context.videos && context.videos.length) && <>


            {/* <div className="x_menu_line">
              <div className="x_search_input0">
                <Input
                  style={{
                    minWidth: '12em',
                    width: 'auto',
                  }}
                  className="x_search_input0"
                  placeholder='Search by name'
                  prefix={<SearchOutlined />}
                  allowClear
                  value={context.state.search}
                  onChange={(e) => context.x.setSearch(e.target.value)}
                />
              </div>
            </div> */}


            <div className="_fv _fgap0">

              <div className="x_menu_line " >
                <div className="x_menu_sub x_menu_sub--y">

                  <div className="_fcc _f100">
                    {/* <div className="x_menu_sub_h" style={{ width: 'auto', paddingBottom: '0' }}>
                  <div className="x_menu_sub_h1">{texts[context.state.language].ui.filterVenue}</div>
                  </div> */}

                    <Select
                      className="_fgrow"
                      labelInValue
                      size="large"
                      value={context.state.filterVenue ? { value: context.state.filterVenue } : undefined}
                      placeholder="All venues"
                      style={{
                        width: '100%',
                      }}
                      onChange={handleVenue}
                      onSelect={() => smoothScrollTo('videos')}
                      allowClear
                      options={[
                        {
                          value: '',
                          label: <div className="_f _fgap02">
                            <b>All venues</b>
                            <div className="x_menu_sub_counter _o04  _fr _f100">{context.videos.length}</div>
                          </div>
                        },
                        ...context.venues.map(one => ({
                          value: one.id,
                          label: (
                            <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                              <div className="x_menu_sub_text">
                                <div className="x_menu_sub_title">{one.title}</div>
                                <div className="x_menu_sub_sub">{one.sub_title}</div>
                              </div>
                              <div className="x_menu_sub_counter _o04">{one.videos.length}</div>
                            </div>
                          )
                        }))
                      ]}
                    />
                  </div>

                </div>
              </div>

              <div className="x_menu_line">
                <div className="x_menu_sub x_menu_sub--y">

                  <div className="_fcc _f100">
                    {/* <div className="x_menu_sub_h" style={{ width: 'auto', paddingBottom: '0' }}>
                  <div className="x_menu_sub_h1">{texts[context.state.language].ui.filterYear}</div>
                </div> */}

                    <Select
                      className="_fgrow"
                      size="large"
                      labelInValue
                      value={context.state.filterYear ? { value: context.state.filterYear } : undefined}
                      placeholder="All years"
                      style={{
                        width: '100%',
                      }}
                      onChange={handleYear}
                      onSelect={() => smoothScrollTo('videos')}
                      allowClear
                      options={[
                        {
                          value: '',
                          label: <div className="_f _fgap02">
                            <b>All years</b>
                            <div className="x_menu_sub_counter _o04  _fr _f100">{context.videos.length}</div>
                          </div>
                        },
                        ...[...new Set(context.videos.map(one => one.date.split('-')[0]))]
                          .sort((a, b) => b - a)
                          .map(one => ({
                            value: one,
                            label: <div className="_f _fgap02">
                              <b>{one}</b>
                              <div className="x_menu_sub_counter _o04  _fr _f100">{context.videos.filter(v => v.date.split('-')[0] === one).length}</div>
                            </div>
                          }))
                      ]}
                    />

                  </div>


                  {/* {[...new Set(context.videos.map(one => one.date.split('-')[0]))]
                  .sort((a, b) => b - a)
                  .map(one => {
                    return <a href="#videos" className={`x_menu_sub_li x_menu_sub_li--y ${context.state.filterYear === one ? 'active' : ''}`}
                      onClick={() => handleYear(one)}
                      key={`year-${one}`}>
                      <div className="x_menu_sub_text">
                        <div className="x_menu_sub_title">{one}</div>
                      </div>
                      <div className="x_menu_sub_counter _o04">{context.videos.filter(v => v.date.split('-')[0] === one).length}</div>
                    </a>
                  })} */}


                </div>
              </div>

            </div>


          </>}

          {/* <Button type={'secondary'} onClick={() => reset()}>Clear<span className='mobile_v_no'> filters</span></Button> */}





        </div>



      </div>






    </>
  )
}



export function FiltersSelect(props) {
  const context = { ...useContext(Context) };
  const { children } = { ...props };
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [state, setState] = useState();

  const handleVenue = (value) => {
    console.log(value); // { value: "lucy", key: "lucy", label: "Lucy (101)" }
    context.x.setFilterVenue(value.value)
  };
  const handleYear = (value) => {
    console.log(value); // { value: "lucy", key: "lucy", label: "Lucy (101)" }
    context.x.setFilterYear(value.value)
  };
  const reset = () => {
    handleVenue({ value: '' })
    handleYear({ value: '' })
    context.x.setSearch('')
  };

  return (
    <>

      <div className="x_v_search_cols ">

        {Boolean(context.videos && context.videos.length) && <>

          <Input
            style={{
              minWidth: '12em',
              width: 'auto',
            }}
            placeholder='Search by name'
            prefix={<SearchOutlined />}
            allowClear
            value={context.state.search}
            onChange={(e) => context.x.setSearch(e.target.value)}
          />


          <Select
            labelInValue
            value={{ value: context.state.filterYear }}
            defaultValue={{
              value: '',
              label: <div className="_f _fgap02">
                <b>All venues</b>
                <div className="x_menu_sub_counter _o04  _fr _f100">{context.videos.length}</div>
              </div>
            }}
            style={{
              width: '12em',
            }}
            onChange={handleYear}
            options={[{
              value: '',
              label: <div className="_f _fgap02">
                <b>All years</b>
                <div className="x_menu_sub_counter _o04  _fr _f100">{context.videos.length}</div>
              </div>
            },
            ...[...new Set(context.videos.map(one => one.date.split('-')[0]))]
              .sort((a, b) => b - a)
              .map(one => ({
                value: one,
                label: <div className="_f _fgap02">
                  <b>{one}</b>
                  <div className="x_menu_sub_counter _o04 _fr _f100">{context.videos.filter(v => v.date.split('-')[0] === one).length}</div>
                </div>
              }))
            ]}
          />



          {context.videos && <Select
            labelInValue
            value={{ value: context.state.filterVenue }}
            defaultValue={{
              value: '',
              label: <div className="_f _fgap02">
                <b>All venues</b>
                <div className="x_menu_sub_counter _o04 _fr _f100">{context.videos.length}</div>
              </div>
            }}
            style={{
              minWidth: '15em',
              maxWidth: '40em',
              width: '100%',
            }}
            onChange={handleVenue}
            options={[{
              value: '',
              label: <div className="_f _fgap02">
                <b>All venues</b>
                <div className="x_menu_sub_counter _o04 _fr _f100">{context.videos.length}</div>
              </div>
            },
            ...context.venues.map(one => ({
              value: one.id,
              label: <>
                <div className="_f _fgap02">
                  <b>{one.title}</b>
                  <div className="mobile_v_no">{one.sub_title}</div>
                  {one.videos && <div className="x_menu_sub_counter _o04 _fr _f100">{one.videos.length}</div>}
                </div>
              </>,
            }))
            ]}
          />}


        </>}

        <Button type={'secondary'} onClick={() => reset()}>Clear<span className='mobile_v_no'> filters</span></Button>



      </div>






    </>
  )
}